import React from 'react';
import {getPublicImagePath, Modal} from '@nutastic/nutastic-react-app';

// eslint-disable-next-line react/prop-types
const PriceSheet = ({ onClose, isActive }) => {
    const componentClass = 'priceSheetModal';
    return <Modal
        show={isActive}
        className={componentClass}
        title={null}
        closeOnOuterClick={true}
        onClose={onClose}
        closeBtn={<i className="ion-md-close-circle" />}
    >
        <img src={getPublicImagePath('mvibes-price-sheet.jpg')} alt="Manifesting Vibes | Price Sheet" />
    </Modal>;
};

export default PriceSheet;
